let isAuthenticated = false;
let token = '';

export default {
  login(token) {
    isAuthenticated = true;
    //token = Math.random().toString(36).substring(7)
    localStorage.setItem('token', token);
  },

  logout() {
    isAuthenticated = false;
    token = '';
    localStorage.removeItem('token');
  },

  get isAuthenticated() {
    const storedToken = localStorage.getItem('token');
    if (storedToken && storedToken.length > 0) {
      isAuthenticated = true;
      token = storedToken;
    } else {
      isAuthenticated = false;
      token = '';
    }
    return isAuthenticated;
  },

  get token() {
    return token;
  }
};
